'use strict'
import React, { useEffect, useState } from 'react'
import { setCartographyBackground } from './mapTreatments/AddingLayers'
import i18n from 'simple-react-i18n'
import { DEFAULT_MAP_BACKGROUND, homeSelectedBackground, MAP_BACKGROUNDS_TO_HIDE } from 'carto/constants/CartoConstants'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import AdministrationAction from '../../administration/actions/AdministrationAction'
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'
import { darkBlue } from 'utils/constants/ColorTheme'
import { getMapBackgrounds } from 'utils/mapUtils/MapBackgroundsUtils'
import useApplicationSetting from 'utils/customHook/useApplicationSetting'
import { compact } from 'lodash'


const CartographyBackgroundPanel = () => {
    const {
        settings,
        applicationSettings,
    } = useSelector(store => ({
        settings: store.AdministrationReducer.settings,
        applicationSettings: store.AdministrationReducer.applicationSettings,
    }), shallowEqual)

    const getSelectedBackgroundParameter = () => {
        const selectedBackgroundParameter = settings.find(s => s.parameter === homeSelectedBackground)?.value
        const defaultBackground = applicationSettings.find(s => s.parameter === DEFAULT_MAP_BACKGROUND)?.value
        const mapBackgroundsToHide = applicationSettings.find(s => s.parameter === MAP_BACKGROUNDS_TO_HIDE)?.value
        return (!selectedBackgroundParameter || mapBackgroundsToHide?.includes(selectedBackgroundParameter)) ? defaultBackground : selectedBackgroundParameter
    }

    const [dataLoaded, setDataLoaded] = useState(false)
    const [backgroundType, setBackgroundType] = useState(getSelectedBackgroundParameter())

    const dispatch = useDispatch()

    const saveCartographyBackground = (background) => {
        dispatch(AdministrationAction.updateSetting(homeSelectedBackground, background))
    }

    const getCheckBox = (background) => (
        <Grid
            container
            justifyContent='space-between'
            onClick={() => {
                setCartographyBackground(background.name)
                saveCartographyBackground(background.name)
                setBackgroundType(background.name)
            }}
        >
            <Grid size='grow' container alignItems='center' spacing={1} sx={{ height: '60px' }}>
                <input className='sieau-input' type='radio' id={background.name} checked={backgroundType === background.name} />
                <label htmlFor={background.name} />
                <Typography variant='h5' sx={{ fontWeight: 'bold' }}>{background.label}</Typography>
            </Grid>
            <Grid>
                {background.img && (
                    <img src={background.img} alt={background.label} style={{ width: 150, height: 'auto', maxHeight: 60, overflow: 'hidden' }} />
                )}
            </Grid>
        </Grid>
    )

    const setBackgroundState = () => {
        const bt = getSelectedBackgroundParameter()
        setCartographyBackground(bt)
        setDataLoaded(true)
        setBackgroundType(bt)
    }

    useEffect(() => {
        if (!settings.length) {
            dispatch(AdministrationAction.fetchSettings()).then(() => {
                setBackgroundState()
            })
        } else {
            setBackgroundState()
        }
    }, [])

    const mapBackgroundsToHide = useApplicationSetting(MAP_BACKGROUNDS_TO_HIDE, s => compact(s?.split(',')?.map(b => b.trim()))) || []

    if (dataLoaded) {
        return (
            <Card onClick={(e) => e.stopPropagation()}>
                <CardTitle title={i18n.backgroundLayers} color={darkBlue} />
                <CardContent sx={{ padding: 2 }}>
                    <Stack spacing={2.5}>
                        {getMapBackgrounds().filter(bg => !mapBackgroundsToHide.includes(bg.name)).map(bg => getCheckBox(bg))}
                    </Stack>
                </CardContent>
            </Card>
        )
    }
    return null
}

export default CartographyBackgroundPanel